<!-- add-ticket-dialog.component.html -->
<div class="dialog-container" dir="rtl">
  <!-- Header -->
  <div
    class="dialog-header"
    style="display: flex; justify-content: space-between"
  >
    <h2 class="dialog-title">إضافة تذكرة دعم</h2>
    <button class="close-btn" (click)="close()">×</button>
  </div>

  <!-- Content -->
  <div class="dialog-content">
    <div class="form-row">
      <label for="callType">نوع المكالمة</label>
      <select id="callType" [(ngModel)]="callType" class="form-control">
        <option *ngFor="let opt of callTypes" [value]="opt.value">
          {{ opt.label }}
        </option>
      </select>
    </div>

    <div class="form-row">
      <label for="inquiryType">نوع التذكرة</label>
      <select
        id="inquiryType"
        [(ngModel)]="inquiryType"
        (ngModelChange)="onTicketTypeChange($event)"
        class="form-control"
      >
        <option *ngFor="let opt of inquiryTypes" [value]="opt.value">
          {{ opt.label }}
        </option>
      </select>
    </div>

    <div class="form-row">
      <label for="inquirySubType">نوع التذكرة الفرعية</label>
      <select
        id="inquirySubType"
        [(ngModel)]="inquirySubType"
        class="form-control"
      >
        <option value="0">None</option>
        <!-- Add dynamic options later if needed -->
      </select>
    </div>

    <div class="form-row">
      <label for="ticketBranch">الفرع</label>
      <select id="ticketBranch" [(ngModel)]="ticketBranch" class="form-control">
        <option *ngFor="let b of branches" [value]="b.value">
          {{ b.label }}
        </option>
      </select>
    </div>

    <div class="form-row">
      <label for="message">الرسالة</label>
      <textarea
        id="message"
        rows="4"
        [(ngModel)]="message"
        class="form-control"
      ></textarea>
    </div>

    <!-- ──────────────────────────────────────────────── -->
    <!-- Conditional fields - exactly like your screenshots -->
    <!-- ──────────────────────────────────────────────── -->

    <div class="form-row" *ngIf="showSurveySelector">
      <label for="surveyType">إستطلاع الرأي</label>
      <select id="surveyType" [(ngModel)]="surveyType" class="form-control">
        <option *ngFor="let opt of surveyOptions" [value]="opt.value">
          {{ opt.label }}
        </option>
      </select>
    </div>

    <div class="form-row" *ngIf="showTransferToLocation">
      <label for="locationTo">إلى فرع</label>
      <select id="locationTo" [(ngModel)]="locationTo" class="form-control">
        <!-- Populate from API -->
        <option value="">اختر الفرع</option>
      </select>
    </div>

    <div class="form-row" *ngIf="showTransferToWhom">
      <label for="transferToWhom">إلى عميل</label>
      <input
        type="text"
        id="transferToWhom"
        [(ngModel)]="transferToWhom"
        maxlength="64"
        class="form-control"
      />
    </div>

    <div class="form-row" *ngIf="showTransferComplain">
      <label for="complaintText">رقم الشكوى</label>
      <input
        type="text"
        id="complaintText"
        [(ngModel)]="complaintText"
        maxlength="64"
        class="form-control"
      />
    </div>

    <div class="form-row" *ngIf="showPersonalNational">
      <label for="nationalId">الرقم القومي</label>
      <input
        type="text"
        id="nationalId"
        [(ngModel)]="nationalId"
        maxlength="14"
        class="form-control"
      />
    </div>

    <div class="form-row" *ngIf="showLostFoundArea">
      <label for="areaFound">مكان الإيجاد</label>
      <input
        type="text"
        id="areaFound"
        [(ngModel)]="areaFound"
        maxlength="100"
        class="form-control"
      />
    </div>

    <div class="form-row" *ngIf="showPersonalSalary">
      <label for="monthlySalary">الراتب الشهري</label>
      <input
        type="number"
        id="monthlySalary"
        [(ngModel)]="monthlySalary"
        class="form-control"
      />
    </div>

    <div class="form-row" *ngIf="showPersonalPhone">
      <label for="preferredMobile">رقم الهاتف المفضل</label>
      <input
        type="text"
        id="preferredMobile"
        [(ngModel)]="preferredMobile"
        maxlength="11"
        class="form-control"
      />
    </div>

    <div class="form-row" *ngIf="showPersonalJobTitle">
      <label for="jobTitle">المسمى الوظيفي</label>
      <input
        type="text"
        id="jobTitle"
        [(ngModel)]="jobTitle"
        maxlength="64"
        class="form-control"
      />
    </div>

    <div class="form-row" *ngIf="showPersonalEmploymentDate">
      <label for="dateOfEmployment">تاريخ التعيين</label>
      <input
        type="date"
        id="dateOfEmployment"
        [(ngModel)]="dateOfEmployment"
        class="form-control"
      />
    </div>
  </div>

  <!-- Footer -->
  <div class="dialog-actions">
    <button class="btn btn-primary" (click)="save()">تسجيل</button>
    <button class="btn btn-secondary" (click)="close()">إغلاق</button>
  </div>
</div>
